import { useState,useEffect } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import { WrapperTickets, Input } from './styles';
import {useDispatch, useSelector} from "react-redux";
import {
  reportesTicketsInit,
  getCatFallas,
  getCatStatus,
  getCatTipoTicket, getCatTipoReq
} from "../../../../store/fuse/reportes-tickets";


const SearchTickets = ({ filters, actualizarFiltros, initTickets }) => {
  const dispatch = useDispatch();
  const initFallas = () => dispatch(getCatFallas());
  const fallas = useSelector((state) => state.fuse?.reportesTickets?.fallas);
  const initStatus = () => dispatch(getCatStatus());
  const statusTicket = useSelector((state) => state.fuse?.reportesTickets?.statusTicket);
  const initTipoTicket = () => dispatch(getCatTipoTicket());
  const tipoTicket = useSelector((state) => state.fuse?.reportesTickets?.tipoTicket);
  const initTipoReq = () => dispatch(getCatTipoReq());
  const tipoReq = useSelector((state) => state.fuse?.reportesTickets?.tipoReq);
  const [motivo, setMotivo] = useState('');
  const [criticidad, setCriticidad] = useState(0);
  const [tipoFalla, setTipoFalla] = useState(0);
  const [statusTicketSel, setStatusTicketSel] = useState(0);
  const [tipoTicketSel, setTipoTicketSel] = useState(0);
  const [tipoReqSel, setTipoReqSel] = useState(0);
  const [numReporte, setNumReporte] = useState('');
  const [numBestel, setNumBestel] = useState('');

  
  const handleFalla = (event) => {
    const  value = event.target.value
    setTipoFalla(value);
  };
  
  const handleTipoTicket = (event) => {
    const  value = event.target.value;
    setTipoTicketSel(value);
  };

  const handleTipoReq = (event) => {
    const  value = event.target.value;
    setTipoReqSel(value,);
  };

  const handleStatus = (event) => {
    const  value = event.target.value;
    setStatusTicketSel(value);
  };
  
  const handleCriticidad= (event) => {
    const value = event.target.value;
    setCriticidad(value);
  };
  
  const initFilters = ()=>{
    dispatch(reportesTicketsInit());
    initFallas()
    initStatus()
    initTipoTicket()
    initTipoReq()
  }
  
  const getTicketsFind = ()=>{
    actualizarFiltros({
      criticidadTicket: criticidad,
      tipoFalla: tipoFalla,
      ticketStatus: statusTicketSel,
      tipoTicket: tipoTicketSel,
      tipoRequerimiento: tipoReqSel,
      numReporteSoc: numReporte,
      numReporteBestel: numBestel
    });
  }
  
  useEffect(() => {
    initFilters()
  }, []);
  
  

  return (
    <WrapperTickets>
      <strong>Búsqueda de Tickets</strong>
      <Box
        component="form"
        sx={{
          '& > :not(style)': { m: 1, width: '100%' },
        }}
        noValidate
        autoComplete="off"
        style={{
          display: 'grid',
        }}
      >
        <div className="section-form">
          <div className="section-one-form">
            <Input>
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                N° Reporte(SOC)
              </InputLabel>
              <TextField
                id="outlined-basic"
                label="Ingresa el número de reporte del SOC"
                variant="outlined"
                type="text"
                name="no_reporte"
                value={numReporte}
                onChange={ e => setNumReporte(e.target.value) }
                fullWidth
                style={{
                  width: '98%',
                  margin: '2% 2% 2% 0%',
                }}
              />
            </Input>
            <Input>
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                N° Reporte(Bestel)
              </InputLabel>
              <TextField
                id="outlined-basic"
                label="Ingresa el número de reporte de Bestel"
                variant="outlined"
                type="text"
                name="no_reporte"
                value={numBestel}
                onChange={ e => setNumBestel(e.target.value) }
                fullWidth
                style={{
                  width: '98%',
                  margin: '2% 2% 2% 0%',
                }}
              />
            </Input>
            <Input>
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                Tipo Falla
              </InputLabel>
              <FormControl
                style={{
                  width: '98%',
                  margin: '2% 2% 2% 0%',
                }}
              >
                <InputLabel htmlFor="my-input">Selecciona el tipo de falla</InputLabel>
                <Select labelId="falla" id="demo-simple-select" label="falla" onChange={handleFalla}>
                  <MenuItem value={0} >Seleccione el tipo de falla</MenuItem>
                  {fallas?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.dsTipoFalla}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Input>
            <Input>
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                Estatus Ticket
              </InputLabel>
              <FormControl
                style={{
                  width: '98%',
                  margin: '2% 2% 2% 0%',
                }}
              >
                <InputLabel htmlFor="my-input">Selecciona el estatus</InputLabel>
                <Select labelId="status" id="demo-simple-select" label="status" onChange={handleStatus}>
                  <MenuItem value={0}>Seleccione el estatus</MenuItem>
                  {statusTicket?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.dsTicketStatus}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Input>
          </div>
          <div className="section-two-form">
            <Input>
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                Afectación
              </InputLabel>
              <TextField
                id="outlined-basic"
                label="Ingresa el tipo de afectación"
                variant="outlined"
                type="text"
                name="no_reporte"
                // value={}
                // onChange={ e => setNombreCasa(e.target.value) }
                fullWidth
                style={{
                  width: '98%',
                  margin: '2% 2% 2% 0%',
                }}
              />
            </Input>
            <Input>
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                Tipo Ticket
              </InputLabel>
              <FormControl
                style={{
                  width: '98%',
                  margin: '2% 2% 2% 0%',
                }}
              >
                <InputLabel htmlFor="my-input">Selecciona el tipo de ticket</InputLabel>
                <Select labelId="tipot" id="demo-simple-select" label="tipot" onChange={handleTipoTicket}>
                  <MenuItem value={0}>Seleccione el tipo de ticket</MenuItem>
                  {tipoTicket?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.dsTicketTipo}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Input>
            <Input>
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                Tipo Requerimiento
              </InputLabel>
              <FormControl
                style={{
                  width: '98%',
                  margin: '2% 2% 2% 0%',
                }}
              >
                <InputLabel htmlFor="my-input">Selecciona el tipo de requerimiento</InputLabel>
                <Select labelId="req" id="demo-simple-select" label="req" onChange={handleTipoReq}>
                  <MenuItem value={0}>Seleccione el tipo de requerimiento</MenuItem>
                  {tipoReq?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.dsRequerimiento}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Input>
            <Input>
              <InputLabel htmlFor="my-input" style={{ margin: '10px 10px 10px 0px' }}>
                Criticidad
              </InputLabel>
              <FormControl
                style={{
                  width: '98%',
                  margin: '2% 2% 2% 0%',
                }}
              >
                <InputLabel htmlFor="my-input">Selecciona la criticidad</InputLabel>
                <Select labelId="motivo" id="demo-simple-select" label="motivo" value={motivo} onChange={handleCriticidad}>
                  <MenuItem  value={0} >Seleccione la criticidad</MenuItem>
                  <MenuItem  value={1}>Alta</MenuItem>
                  <MenuItem  value={2}>Media</MenuItem>
                  <MenuItem  value={3}>Baja</MenuItem>
                </Select>
              </FormControl>
            </Input>
            <div className="section-button">
              <Button  variant="contained" color="info" size="large" onClick={getTicketsFind}
                       sx={{
                         color: '#FFFFFF', 
                       }}>
                Buscar
              </Button>
            </div>
          </div>
        </div>
      </Box>
    </WrapperTickets>
  );
};


export default SearchTickets;
